module.exports = __webpack_public_path__ + "img/notice_bg.1d178b17.png";